import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase/firebaseConfig';

const AccessExpired = () => {
    const navigate = useNavigate();

    const handleSignOut = async () => {
        await auth.signOut();
        navigate('/');
    };

    return (
        <div style={{
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            minHeight: '100vh', backgroundColor: '#f5f5f5', fontFamily: 'Arial, sans-serif',
        }}>
            <div style={{
                backgroundColor: '#fff', padding: '40px', borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)', maxWidth: '450px', width: '100%',
                textAlign: 'center',
            }}>
                <h1 style={{ color: '#4b2e83', marginBottom: '16px', fontSize: '24px' }}>
                    Trial Expired
                </h1>
                <p style={{ color: '#666', fontSize: '15px', lineHeight: '1.6', marginBottom: '24px' }}>
                    Your free trial has expired. To continue using eduventra learning,
                    please contact us to upgrade your account.
                </p>
                <a
                    href="mailto:support@eduventralearning.com?subject=Trial%20Upgrade%20Request"
                    style={{
                        display: 'inline-block', padding: '12px 24px',
                        backgroundColor: '#4b2e83', color: '#fff',
                        border: 'none', borderRadius: '6px', fontSize: '16px',
                        fontWeight: 'bold', textDecoration: 'none', cursor: 'pointer',
                    }}
                >
                    Contact Us to Upgrade
                </a>
                <div style={{ marginTop: '20px' }}>
                    <button
                        onClick={handleSignOut}
                        style={{
                            background: 'none', border: 'none', color: '#4b2e83',
                            cursor: 'pointer', fontSize: '13px', textDecoration: 'underline',
                        }}
                    >
                        Sign Out
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AccessExpired;
